import { set as setStore, get as getStore } from '../browser-storage/localStorage';
import { v4 as uuidv4 } from 'uuid';

const version = 3.0;

// export const getDeviceFingerprint = (uniqueId: string, isGuest = false) => {
//     const store = isGuest ? getStore('deviceIdGuest') : getStore('deviceId');
//     if (store && store.id && store.version === version && store.user === uniqueId) {
//         return store.id;
//     }
//     const keys = [];
//     keys.push(getBrowser());
//     keys.push(uniqueId);
//     const deviceId = btoa(uniqueId + '_' + murmurhash3_32_gc(keys.join(`-${uniqueId}-`), 31)).replace(/=/g, '_');
//     setStore(isGuest ? 'deviceIdGuest' : 'deviceId', { id: deviceId, version: version, user: uniqueId });
//     return deviceId;
// };

export const getDeviceFingerprint = (uniqueId: string, isGuest = false): string => {
    const storageKey = isGuest ? 'deviceIdGuest' : 'deviceId';
    const store = getStore(storageKey);

    if (store && store.id && store.version === version && store.user === uniqueId) {
        return store.id;
    }

    const browser = getBrowser();
    const platform = navigator.platform;
    const language = navigator.language;
    const resolution = `${window.screen.width}x${window.screen.height}`;
    const timezoneOffset = new Date().getTimezoneOffset();

    const extraFingerprint = `${platform}-${language}-${resolution}-${timezoneOffset}`;
    const combinedFingerprint = `${browser}-${uniqueId}-${extraFingerprint}`;

    const hashed = murmurhash3_32_gc(combinedFingerprint, 31);
    const deviceId = btoa(`${uniqueId}_${hashed}`).replace(/=/g, '_');

    setStore(storageKey, {
        id: deviceId,
        version: version,
        user: uniqueId,
    });

    return deviceId;
};

export const getBrowser = () => {
    if (
        (typeof (window as any)['opr'] !== 'undefined' && !!(window as any)['opr']['addons']) ||
        !!(window as any)['opera'] ||
        navigator?.userAgent.indexOf(' OPR/') >= 0
    )
        return 'opera';
    if (typeof (window as any)?.InstallTrigger !== 'undefined') return 'firefox';
    if (/^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent)) return 'safari';
    if (
        (typeof (window as any)['isIE'] === 'undefined' && !!(window as any)?.StyleMedia) ||
        /(edg\/)/i.test(navigator.userAgent)
    )
        return 'edge';
    if (typeof navigator !== 'undefined' && 'brave' in navigator && typeof (navigator?.brave !== 'undefined')) {
        return 'brave';
    }
    if (/(chrome|crios)/i.test(navigator.userAgent)) return 'chrome';
    return 'unknown';
};

export const murmurhash3_32_gc = (key: any, seed: any) => {
    const remainder = key.length & 3;
    const bytes = key.length - remainder;
    let h1, h1b, k1, i;
    h1 = seed;
    const c1 = 0xcc9e2d51;
    const c2 = 0x1b873593;
    i = 0;
    while (i < bytes) {
        k1 =
            (key.charCodeAt(i) & 0xff) |
            ((key.charCodeAt(++i) & 0xff) << 8) |
            ((key.charCodeAt(++i) & 0xff) << 16) |
            ((key.charCodeAt(++i) & 0xff) << 24);
        ++i;
        k1 = ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
        k1 = (k1 << 15) | (k1 >>> 17);
        k1 = ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
        h1 ^= k1;
        h1 = (h1 << 13) | (h1 >>> 19);
        h1b = ((h1 & 0xffff) * 5 + ((((h1 >>> 16) * 5) & 0xffff) << 16)) & 0xffffffff;
        h1 = (h1b & 0xffff) + 0x6b64 + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16);
    }
    k1 = 0;
    switch (remainder) {
        case 3:
            k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
            break;
        case 2:
            k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
            break;
        case 1:
            k1 ^= key.charCodeAt(i) & 0xff;
            k1 = ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
            k1 = (k1 << 15) | (k1 >>> 17);
            k1 = ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
            h1 ^= k1;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = ((h1 & 0xffff) * 0x85ebca6b + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
    h1 ^= h1 >>> 13;
    h1 = ((h1 & 0xffff) * 0xc2b2ae35 + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16)) & 0xffffffff;
    h1 ^= h1 >>> 16;
    return h1 >>> 0;
};
